var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage71({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M15.39 9.375c1.215 0 2.292.737 2.97 1.875m-17.11 0A4.68 4.68 0 0 1 5 9.375m5 5a3.125 3.125 0 1 0 0-6.25 3.125 3.125 0 0 0 0 6.25"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#292929",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.625 16.875a5.077 5.077 0 0 1 8.75 0M12.578 6.25A2.5 2.5 0 1 1 15 9.375m-10 0A2.5 2.5 0 1 1 7.422 6.25"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage71);
export default __webpack_public_path__ + "static/media/image71.58c4f1e1357d22059ad2682a3b377a94.svg";
export { ForwardRef as ReactComponent };